"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        var ProxyMessageCenterManager;
        (function (ProxyMessageCenterManager) {
            function getMessageIds(messages) {
                var messageIds = [];
                for (var i = 0, len = $dyn.length(messages); i < len; i++) {
                    var message = messages[i];
                    if (message instanceof $dyn.messaging.Message) {
                        messageIds.push(message.Id);
                    }
                    else if (message instanceof $dyn.messaging.PrefixRootMessage) {
                        $dyn.serverForm.ProxyMessageCenterManager.getPrefixMessageIds(message.prefixSection, messageIds);
                    }
                }
                return messageIds;
            }
            ProxyMessageCenterManager.getMessageIds = getMessageIds;
            function getPrefixMessageIds(prefixSection, messageIds) {
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < prefixSection.messages.length; i++) {
                    var message = prefixSection.messages[i];
                    if (message instanceof $dyn.messaging.Message) {
                        messageIds.push(message.Id);
                    }
                    else if (message instanceof $dyn.messaging.PrefixRootMessage) {
                        $dyn.serverForm.ProxyMessageCenterManager.getPrefixMessageIds(message.prefixSection, messageIds);
                    }
                }
                if (prefixSection.prefixSection !== undefined) {
                    $dyn.serverForm.ProxyMessageCenterManager.getPrefixMessageIds(prefixSection.prefixSection, messageIds);
                }
            }
            ProxyMessageCenterManager.getPrefixMessageIds = getPrefixMessageIds;
            function AddMessage(message) {
                $dyn.serverForm.ProxyMessageCenterManager.AddMessages([message]);
            }
            ProxyMessageCenterManager.AddMessage = AddMessage;
            function AddMessages(messages) {
                var data = {
                    commandName: "ReplayMessageOnMainWindow",
                    messageIds: $dyn.serverForm.ProxyMessageCenterManager.getMessageIds(messages),
                    source: "MessageCenter",
                };
                return $dyn.postMessage($dyn.parentWindow, { data: data });
            }
            ProxyMessageCenterManager.AddMessages = AddMessages;
            function ClearMessages() {
                var data = {
                    commandName: "ClearMessages",
                    source: "MessageCenter",
                };
                return $dyn.postMessage($dyn.parentWindow, { data: data });
            }
            ProxyMessageCenterManager.ClearMessages = ClearMessages;
            function RemoveMessages(deleteMessages) {
                for (var i = 0, len = $dyn.length(deleteMessages); i < len; i++) {
                    var message = deleteMessages[i];
                    $dyn.serverForm.ProxyMessageCenterManager.RemoveMessage(message.messageId);
                }
            }
            ProxyMessageCenterManager.RemoveMessages = RemoveMessages;
            function RemoveMessage(messageId) {
                var data = {
                    commandName: "RemoveMessage",
                    messageId: messageId,
                    source: "MessageCenter",
                };
                return $dyn.postMessage($dyn.parentWindow, { data: data });
            }
            ProxyMessageCenterManager.RemoveMessage = RemoveMessage;
            function GetMessage(messageId) {
                return null;
            }
            ProxyMessageCenterManager.GetMessage = GetMessage;
        })(ProxyMessageCenterManager = serverForm.ProxyMessageCenterManager || (serverForm.ProxyMessageCenterManager = {}));
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ProxyMessageCenterManager.js.map
